import { environment } from "../../config";
import {
  iDataOrganizacion,
  PostOrgFields,
  PutOrgFields,
} from "../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { iDataUserOrganization } from "../../interfaces/SuperAdmin/Pages/iDataUserOrganization";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL, VERSION } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

/* 
------------------------------------------------- 
ORGANIZACION
-------------------------------------------------
*/

export const getAllOrganizations = (version: string | undefined = VERSION) =>
  fetchData<iDataOrganizacion[]>({
    method: "GET",
    url: `${baseApiBroker}/organizacion`,
    params: { version },
  });

//getOrganizationByUserID
export const getOrganizationById = (id: string) =>
  fetchData<iDataOrganizacion>({
    method: "GET",
    url: `${baseApiBroker}/organizacion/${id}`,
  });

export const postOrganization = (data: PostOrgFields) =>
  fetchData<iDataOrganizacion>({
    method: "POST",
    url: `${baseApiBroker}/organizacion`,
    data,
  });

export const deleteOrganizationById = (id: string) =>
  fetchData<{}>({
    method: "DELETE",
    url: `${baseApiBroker}/organizacion/${id}`,
  });

export const putOrganizationById = (id: string, data: PutOrgFields) =>
  fetchData<iDataOrganizacion>({
    method: "PUT",
    url: `${baseApiBroker}/organizacion/${id}`,
    data,
  });

/* 
------------------------------------------------- 
USUARIO-ORGANIZACION
-------------------------------------------------
*/

export const postUserInOrganization = (
  id_usuario: string,
  id_organizacion: string
) =>
  fetchData<iDataUserOrganization>({
    method: "POST",
    url: `${baseApiBroker}/usuario-organizacion`,
    data: {
      id_usuario,
      id_organizacion,
    },
  });

export const deleteUserInOrganization = (
  id_usuario: string,
  id_organizacion: string
) =>
  fetchData<[]>({
    method: "DELETE",
    url: `${baseApiBroker}/usuario-organizacion/${id_usuario}/${id_organizacion}`,
  });
